class ProjectSettings {
    static get rootVarPrefix()  {
        return '--vowe-';
    }
}

export { ProjectSettings };